export const performanceTracking = {
  "tab_name": "performance-tracking",
  "data": [
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "Academic Performance",
          "value": 78
        },
        {
          "name": "Student Success",
          "value": 82
        },
        {
          "name": "Financial Performance",
          "value": 70
        },
        {
          "name": "International Performance",
          "value": 65
        },
        {
          "name": "Innovation Performance",
          "value": 72
        }
      ]
    },
    {
      "name": "Warwick Business School",
      "series": [
        {
          "name": "Academic Performance",
          "value": 92
        },
        {
          "name": "Student Success",
          "value": 95
        },
        {
          "name": "Financial Performance",
          "value": 85
        },
        {
          "name": "International Performance",
          "value": 90
        },
        {
          "name": "Innovation Performance",
          "value": 88
        }
      ]
    }
  ],
  "table": [
    {
      "university": "University of Hull",
      "academic_performance": 78,
      "student_success": 82,
      "financial_performance": 70,
      "international_performance": 65,
      "innovation_performance": 72,
      "academic_rank": 20,
      "student_rank": 15,
      "financial_rank": 18,
      "international_rank": 25,
      "innovation_rank": 22,
      "overall_score": 73.4
    },
    {
      "university": "Warwick Business School",
      "academic_performance": 92,
      "student_success": 95,
      "financial_performance": 85,
      "international_performance": 90,
      "innovation_performance": 88,
      "academic_rank": 3,
      "student_rank": 1,
      "financial_rank": 5,
      "international_rank": 2,
      "innovation_rank": 4,
      "overall_score": 90.0
    }
  ],
  "chart": {
    "title": "Performance Tracking Analysis - MBA Programs in UK",
    "subtitle": "Academic, Student Success, Financial, International, and Innovation Performance Comparison",
    "chart_type": "radar",
    "x_axis": "Performance Metrics",
    "y_axis": "Score (0-100)",
    "series": [
      {
        "name": "University of Hull",
        "series": [
          {
            "name": "Academic Performance",
            "value": 78
          },
          {
            "name": "Student Success",
            "value": 82
          },
          {
            "name": "Financial Performance",
            "value": 70
          },
          {
            "name": "International Performance",
            "value": 65
          },
          {
            "name": "Innovation Performance",
            "value": 72
          }
        ]
      },
      {
        "name": "Warwick Business School",
        "series": [
          {
            "name": "Academic Performance",
            "value": 92
          },
          {
            "name": "Student Success",
            "value": 95
          },
          {
            "name": "Financial Performance",
            "value": 85
          },
          {
            "name": "International Performance",
            "value": 90
          },
          {
            "name": "Innovation Performance",
            "value": 88
          }
        ]
      }
    ],
    "options": {
      "responsive": true,
      "maintainAspectRatio": false,
      "scales": {
        "r": {
          "beginAtZero": true,
          "max": 100,
          "ticks": {
            "stepSize": 20
          }
        }
      }
    }
  },
  "details": {
    "summary": "Comprehensive performance tracking analysis of 2 universities offering MBA programs in UK",
    "key_findings": [
      "Academic performance varies significantly across universities",
      "Student success metrics correlate with overall institutional performance",
      "Financial performance impacts long-term sustainability",
      "International performance enhances global competitiveness"
    ],
    "methodology": "Analysis based on academic metrics, student success indicators, financial health, international standing, and innovation performance",
    "data_freshness": "Real-time performance data with quarterly updates",
    "confidence_level": "High",
    "sample_size": "Analysis covers 2 major universities"
  },
  "evidence_sources": [
    {
      "category": "academic_performance",
      "source": "QS World University Rankings",
      "confidence": 0.9,
      "url": "https://www.topuniversities.com/world-university-rankings",
      "snippet": "Global university rankings based on academic reputation, employer reputation, and research impact.",
      "type": "rankings",
      "domain": "education"
    },
    {
      "category": "academic_performance",
      "source": "Times Higher Education World University Rankings",
      "confidence": 0.9,
      "url": "https://www.timeshighereducation.com/world-university-rankings",
      "snippet": "Comprehensive university rankings based on teaching, research, knowledge transfer, and international outlook.",
      "type": "rankings",
      "domain": "education"
    },
    {
      "category": "student_success",
      "source": "Graduate Outcomes Survey",
      "confidence": 0.92,
      "url": "https://www.hesa.ac.uk/data-and-analysis/graduates",
      "snippet": "Survey tracking graduate employment outcomes and career progression after university.",
      "type": "official_survey",
      "domain": "education"
    },
    {
      "category": "financial_performance",
      "source": "Higher Education Statistics Agency (HESA)",
      "confidence": 0.95,
      "url": "https://www.hesa.ac.uk/data-and-analysis",
      "snippet": "Official statistics on higher education in the UK including financial data and performance metrics.",
      "type": "official_data",
      "domain": "education"
    },
    {
      "category": "research_performance",
      "source": "Research Excellence Framework (REF)",
      "confidence": 0.93,
      "url": "https://www.ref.ac.uk/",
      "snippet": "Assessment of research quality and impact across UK higher education institutions.",
      "type": "official_assessment",
      "domain": "education"
    }
  ],
  "recommendations": [
    {
      "category": "academic_performance",
      "issue": "Research output enhancement",
      "recommendation": "Increase investment in research infrastructure and faculty development",
      "priority": "High",
      "expected_impact": "Improve academic performance scores by 5-8 points"
    },
    {
      "category": "student_success",
      "issue": "Graduation rate improvement",
      "recommendation": "Implement comprehensive student support programs and academic advising",
      "priority": "High",
      "expected_impact": "Increase student success metrics by 3-6 points"
    },
    {
      "category": "financial_performance",
      "issue": "Financial sustainability",
      "recommendation": "Optimize resource allocation and diversify funding sources",
      "priority": "Medium",
      "expected_impact": "Enhance financial performance by 4-7 points"
    },
    {
      "category": "international_performance",
      "issue": "Global partnerships",
      "recommendation": "Strengthen international collaborations and exchange programs",
      "priority": "Medium",
      "expected_impact": "Boost international performance by 6-10 points"
    },
    {
      "category": "innovation_performance",
      "issue": "Technology adoption",
      "recommendation": "Accelerate digital transformation and innovation initiatives",
      "priority": "High",
      "expected_impact": "Improve innovation performance by 5-9 points"
    }
  ],
  "overall_performance_summary": {
    "title": "University Performance Tracking Analysis",
    "description": "Comprehensive analysis of university performance across multiple dimensions",
    "total_universities_analyzed": 2,
    "average_performance_score": 81.0,
    "performance_distribution": {
      "excellent": 2,
      "good": 3,
      "average": 2,
      "below_average": 1
    }
  },
  "tracking_methodology": {
    "data_collection": "Multi-source data integration",
    "analysis_frequency": "Real-time and quarterly",
    "benchmarking": "National and international standards",
    "reporting": "Comprehensive dashboards and reports"
  },
  "cached": false,
  "timestamp": "2025-08-29T20:28:36.132894",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "performance_tracking",
    "country": "UK",
    "total_universities": 2,
    "course": "MBA",
    "response_time": 49.39,
    "data_sources": [
      "University Performance Reports",
      "Academic Rankings",
      "Financial Data",
      "Student Success Metrics"
    ],
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "performance_tracking_v1",
      "web_search_used": false,
      "total_evidence_sources": 5,
      "web_search_success": false,
      "fallback_sources_used": true
    }
  }
};
